const BASE_URL =process.env.REACT_APP_API_URL;
const API_BASE = `${BASE_URL}/guidewithdrawal`;
const WITHDRAWAL_API_BASE = `${BASE_URL}/withdrawal`;

// Helper GET function
async function getJSON(url, token) {

  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  

  const json = await res.json();

  return json;
}

// ---------------- GUIDE WITHDRAWAL APIs ----------------

//  Eligible Withdrawal Amount
export const getGuideEligibleAmount = (token) =>
  getJSON(`${API_BASE}/eligible-amount`, token);

//  Withdrawal Status (processing, completed)
export const getGuideWithdrawalStatus = (token) =>
  getJSON(`${API_BASE}/status`, token);

// Withdrawal History  (completed payouts only)
export const getGuideWithdrawalHistory = (token) =>
  getJSON(`${API_BASE}/history`, token);

// Request Withdrawal
export const requestGuideWithdrawal = async (token) => {
  const res = await fetch(`${API_BASE}/request`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res.json();
};

//  Save Bank Details
export const saveGuideBankDetails = async (data, token) => {
  const res = await fetch(`${API_BASE}/bank-details`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return res.json();
};
// Eligible withdrawal amount for Agent
export const getAgentEligibleAmount = (token) =>
  getJSON(`${API_BASE}/eligible-amount/agent`, token);

// Request withdrawal for Agent
export const requestAgentWithdrawal = async (token) => {
  const res = await fetch(`${API_BASE}/request/agent`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res.json();
};

export const getAgentWithdrawalHistory = (token) =>
  getJSON(`${WITHDRAWAL_API_BASE}/history`, token);